import {
  Collections,
  FlagName,
  LockAssignments,
  LockAssignmentsDocId,
  LockAssignmentsView,
  selectLockAssignmentsView,
  useDocumentSnapshot,
  useFeatureFlag,
} from '@ozark/common';
import {useCallback} from 'react';

export const useAgentAssignmentsLock = () => {
  const isDateCheckDisabled = useFeatureFlag(FlagName.LOCK_ASSIGNMENTS_DATE_CHECK_DISABLED);
  const {document, set} = useDocumentSnapshot<LockAssignmentsView, LockAssignments>(
    Collections.settings,
    LockAssignmentsDocId,
    selectLockAssignmentsView
  );

  const isLocked = document.data?.isLocked ?? false;
  const loading = document.promised;
  const error = document.error;

  const setLock = useCallback(
    async (lock: boolean) => {
      try {
        await set({isLocked: lock}, true);
      } catch (err: any) {
        console.error('Failed to set lock:', err);
        throw err;
      }
    },
    [set]
  );

  const today = new Date();
  const day = today.getDate();
  let isLockedStatus = false;
  if (isDateCheckDisabled) {
    isLockedStatus = isLocked;
  } else {
    if (day >= 10 && day <= 20) {
      isLockedStatus = isLocked;
    } else {
      isLockedStatus = false;
    }
  }

  return {
    isLocked, // in settings
    isLockedStatus, // with date check
    loading,
    error,
    setLock,
  };
};
